module.exports = __webpack_public_path__ + "static/media/icon_js.edada55e.png";